import React, { useContext, useEffect, useState } from "react";
import { Label } from "../../../../../../stories/Label/Label";
import { Button } from "../../../../../../stories/Button/Button";
import PhoneInput from "react-phone-input-2";
import {
  addCountryCode,
  handleFormEvent,
  handleMUISelectEvent,
  hanldeTextAreaFormEvent,
  removeMoreSpace,
} from "../../../../../../utils/UtilFunctions";
import { Keys } from "../../../../../../utils/Enum.keys";
import { Title } from "../../../../../../stories/Title/Title";
import { subsidaryCreateProps } from "../add/CompanyDetails";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import { useNavigate } from "react-router-dom";
import { Operation } from "../../../../../../utils/Enum.types";
import { Form, Formik, FormikProps } from "formik";
import {
  PredefinedDataTypes,
  subsidiarySiteInputs,
} from "../../../../../../utils/formTypes";
import { subsidiarySiteValidation } from "../../../../../../utils/validationSchema";
import { LabelProps } from "../../../../../../utils/types";
import InputNumber from "../../../../../common/Input/InputNumber";
import PredefinedAutocomplete from "../../../../../../customComponents/PredefinedAutocmplete";
import InputHoc from "../../../../../common/Input/Index";
import {
  EMPTY_STRING,
  emptyMessage,
  ROWS_PER_PAGE,
} from "../../../../../../utils/constants";
import MessageModal from "../../../../../../customComponents/MessageModal";
import {
  GetSubsidiarySiteNodeById,
  GetSubsidiarySites,
} from "../queries/queries";
import {
  nodeVar,
  OrderDirection,
} from "../../../../../../utils/commonQueryTypes";
import {
  AddSubsidiarySiteResult,
  AddSubsidiarySiteVar,
  AtsSubsidiarySite,
  AtsSubsidiarySiteOrderField,
  SiteQueryType,
  UpdateSubsidiarySiteResult,
  UpdateSubsidiarySitesVar,
} from "../queries/types";
import { useLazyQuery, useMutation } from "@apollo/client";
import { AddSubsidiarySite, UpdateSubsidiarySite } from "../queries/mutations";

import useUrlParams from "../../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import { AppContext } from "../../../../../../context/context";
import LoadingModal from "../../../../../pages/LoadingModal";
import PredefinedSelect from "../../../../../../customComponents/PredefinedSelect";
import useLabels from "../../../../../../customHooks/useLabels";
import useFormJson from "../../../../../../json/useFormJson";
import Close from "../../../../../../images/Close.svg";
import IconSelect from "../../../../../../customComponents/IconSelect";

const AssetSite = ({ operation, setModalFlag }: subsidaryCreateProps) => {

  const { SubsidiarySites } = useFormJson();
  const { state } = useContext(AppContext);

  const { customer_id, sub_id, company_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();

  const subsidiarySiteInitialValues: subsidiarySiteInputs = {
    name: "",
    address: "",
    place: "",
    state: "",
    pin: "",
    country: "",
    contactPerson: "",
    contactPersonDesign: "",
    contactPersonEmail: "",
    contactPersonMobile: "",
    email: "",
    mobile: "",
    latitude: "",
    longitude: "",
    gstNo: "",
    icon: "",
  };

  const [
    GetSubSite,
    { data, error, loading: GetSubsidiarySiteNodeByIdLoading },
  ] = useLazyQuery<{ node: AtsSubsidiarySite }, nodeVar>(
    GetSubsidiarySiteNodeById
  );
  const [AddSubDetails, { loading: AddSubsidiarySiteLoading }] = useMutation<
    AddSubsidiarySiteResult,
    AddSubsidiarySiteVar
  >(AddSubsidiarySite, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [UpdateSubDetails, { loading: UpdateSubsidiarySiteLoading }] =
    useMutation<UpdateSubsidiarySiteResult, UpdateSubsidiarySitesVar>(
      UpdateSubsidiarySite,
      {
        onError: (e) => {
          setMessage({
            flag: true,
            message: e.message,
            operation: Operation.NONE,
          });
        },
      }
    );

  const [message, setMessage] = useState(emptyMessage);

  const [formData, setFormData] = useState<subsidiarySiteInputs>(
    subsidiarySiteInitialValues
  );
  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<subsidiarySiteInputs>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
    meta.handleChange(e);
  };

  const handleNumberChange = (name: string, value: string) => {
    setFormData((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const hanldeClear = () => {
    const inputElement = document.getElementsByName(
      "name"
    )[0] as HTMLInputElement;
    if (inputElement) inputElement.focus();

    setFormData(subsidiarySiteInitialValues);
  };

  const handleClose = () => {
    setMessage(emptyMessage);
    if (message.operation !== Operation.NONE) {
      hanldeClear();

      if (message.operation === Operation.UPDATE) setModalFlag(false);
    }
  };

  const handleSubmit = async () => {
    try {

      if (customer_id && company_id) {
        if (operation === Operation.CREATE) {
          const empAdded = AddSubDetails({
            variables: {
              
              user_details,
              customerID: customer_id,
              companyID: company_id,
              subsidiaryID: sub_id ? sub_id : 0,
              input: {
                name: removeMoreSpace(formData.name),
                address: removeMoreSpace(formData.address),
                place: removeMoreSpace(formData.place),
                email: formData.email,
                mobile: addCountryCode(formData.mobile),
                pin: formData.pin,
                state: formData.state,
                contactPerson: removeMoreSpace(formData.contactPerson),
                contactPersonDesign: formData.contactPersonDesign,
                contactPersonEmail: formData.contactPersonEmail,
                contactPersonMobile: addCountryCode(
                  formData.contactPersonMobile
                ),
                country: formData.country,
                latitude: Number(formData.latitude),
                longitude: Number(formData.longitude),
                icon: formData.icon,
              },
            },
            refetchQueries: [
              {
                query: GetSubsidiarySites,
                variables: {
                  
                  after: null,
                  customerID: customer_id,
                  companyID: company_id,
                  subsidiaryID: sub_id
                    ? sub_id
                    : state.subsidiaryId
                    ? state.subsidiaryId
                    : 0,
                  first: ROWS_PER_PAGE,
                  empID: user_details.id,
                  orderBy: {
                    direction: OrderDirection.ASC,
                    field: AtsSubsidiarySiteOrderField.CREATED_AT,
                  },
                  name: EMPTY_STRING,
                  input: {
                    ldgrID: 0,
                    queryType: SiteQueryType.ALL,
                  },
                },
              },
            ],
          });
          const { data } = await empAdded;

          if (data && data.AddSubsidiarySite) {
            setMessage({
              flag: true,
              message: `${subsidiaryLabel} Site added successfully`,
              operation: Operation.CREATE,
            });
          }
        } else {
          const customerUpdated = UpdateSubDetails({
            variables: {
              
              user_details,
              subsidiarySiteID: state.subSiteId,
              input: {
                name: removeMoreSpace(formData.name),
                address: removeMoreSpace(formData.address),
                place: removeMoreSpace(formData.place),
                email: formData.email,
                mobile: addCountryCode(formData.mobile),
                pin: formData.pin,
                state: formData.state,
                contactPerson: removeMoreSpace(formData.contactPerson),
                contactPersonDesign: formData.contactPersonDesign,
                contactPersonEmail: formData.contactPersonEmail,
                contactPersonMobile: addCountryCode(
                  formData.contactPersonMobile
                ),
                country: formData.country,
                latitude: Number(formData.latitude),
                longitude: Number(formData.longitude),
                isActive: "CURR",
                icon: formData.icon,
              },
            },
            refetchQueries: [
              {
                query: GetSubsidiarySites,
                variables: {
                  
                  after: null,
                  customerID: customer_id,
                  companyID: company_id,
                  subsidiaryID: sub_id
                    ? sub_id
                    : state.subsidiaryId
                    ? state.subsidiaryId
                    : 0,
                  empID: user_details.id,
                  first: ROWS_PER_PAGE,
                  orderBy: {
                    direction: OrderDirection.ASC,
                    field: AtsSubsidiarySiteOrderField.CREATED_AT,
                  },
                  name: EMPTY_STRING,
                  input: {
                    id: 0,
                    queryType: SiteQueryType.ALL,
                  },
                },
              },
            ],
          });
          const { data } = await customerUpdated;

          if (data && data.UpdateSubsidiarySite) {
            setMessage({
              flag: true,
              message: `${subsidiaryLabel} Site updated successfully`,
              operation: Operation.UPDATE,
            });
          }
        }
      }
    } catch (err) {
      console.error((err as Error).message);
    }
  };

  useEffect(() => {
    if (state.subSiteId && operation === Operation.UPDATE) {
      GetSubSite({
        variables: {
          id: state.subSiteId,
          
        },
      }).then(({ data }) => {
        if (data && data.node) {
          setFormData({
            name: removeMoreSpace(data.node.name),
            address: removeMoreSpace(data.node.address),
            place: removeMoreSpace(data.node.place),
            email: data.node.email,
            mobile: addCountryCode(data.node.mobile),
            pin: data.node.pin,
            state: data.node.state,
            contactPerson: removeMoreSpace(data.node.contactPerson),
            contactPersonDesign: data.node.contactPersonDesign,
            contactPersonEmail: data.node.contactPersonEmail,
            contactPersonMobile: addCountryCode(
              data.node.contactPersonMobile
            ),
            country: data.node.country,
            gstNo: data.node.gstNo,
            latitude: data.node.latitude.toString(),
            longitude: data.node.longitude.toString(),
            icon: data.node.icon,
          });
        }
      });
    }
  }, [state.subSiteId, GetSubSite, operation]);

  const { itemLabel, subsidiaryLabel } = useLabels();

  return (
    <>
      <div className="subsidarysite__add--title">
        <Title>
          {operation === Operation.CREATE ? "Add " : "Edit "}
          {itemLabel} Site or Location Points
        </Title>
        <img src={Close} alt="" onClick={() => setModalFlag(false)} />
      </div>
      <div className={`subsidarysite__add--edit`}>
        <Formik
          initialValues={formData}
          validationSchema={subsidiarySiteValidation}
          onSubmit={handleSubmit}
          enableReinitialize
          validateOnChange
        >
          {(meta) => {
            return (
              <Form className={`subsidarysite__add--form--edit`}>
                <div className="subsidarysite__add--form-details">
                  <div className="company-details__block--left">
                    <div className="company-details__block--details">
                      <h4>{subsidiaryLabel} Details</h4>
                    </div>
                    {SubsidiarySites.companyDetails.map(
                      (field: LabelProps, key: React.Key) => {
                        if (field.dataType === "textarea") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <TextArea
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLTextAreaElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  type={field.dataType}
                                  rows={3}
                                  name={field.inputName}
                                  required={field.required}
                                  onKeyDown={(e) => {
                                    hanldeTextAreaFormEvent(
                                      e,
                                      setFormData as React.Dispatch<
                                        React.SetStateAction<{
                                          [key: string]: string | number;
                                        }>
                                      >
                                    );
                                  }}
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "number") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <InputNumber
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  name={field.inputName}
                                  required={field.required}
                                  maxLength={field.maxLength}
                                  onKeyDown={handleFormEvent}
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "city") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    place: e,
                                  });
                                }}
                                type={PredefinedDataTypes.CITY}
                                value={formData.place as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "state") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e, state_code) => {
                                  setFormData({
                                    ...formData,
                                    state: e,
                                    gstStateCode: state_code
                                      ? state_code
                                      : EMPTY_STRING,
                                  });
                                }}
                                type={PredefinedDataTypes.STATE}
                                value={formData.state as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "country") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    country: e,
                                  });
                                }}
                                type={PredefinedDataTypes.COUNTRY}
                                value={formData.country as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "mobile") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PhoneInput
                                country={"in"}
                                value={formData[field.inputName] as string}
                                onChange={(e: string) => {
                                  handleNumberChange(field.inputName, e);
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === Keys.ENTER) {
                                    e.preventDefault();
                                    handleMUISelectEvent(e);
                                  }
                                }}
                              />
                              {meta.touched && meta.errors[field.inputName] ? (
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              ) : null}
                            </div>
                          );
                        } else if (field.dataType === "icon") {
                          return (
                            <IconSelect
                              onChange={(newValue) => {
                                if (newValue) {
                                  setFormData({
                                    ...formData,
                                    icon: newValue.value as unknown as string,
                                  });
                                } else {
                                  setFormData({
                                    ...formData,
                                    icon: "",
                                  });
                                }
                              }}
                            />
                          );
                        } else {
                          return (
                            <React.Fragment key={key}>
                              <InputHoc
                                LabelName={field.labelName}
                                values={formData[field.inputName]}
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                required={field.required}
                                autoFocus={field.autoFocus}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        }
                      }
                    )}
                  </div>
                  <div className="company-details__block--right">
                    <div className="company-details__block--details">
                      <h4>Contact Details</h4>
                    </div>
                    {SubsidiarySites.contactDetails.map(
                      (field: LabelProps, key: React.Key) => {
                        if (field.dataType === "textarea") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <TextArea
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLTextAreaElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  type={field.dataType}
                                  rows={3}
                                  name={field.inputName}
                                />
                              </div>

                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "number") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <InputNumber
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  name={field.inputName}
                                  maxLength={field.maxLength}
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "city") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    place: e,
                                  });
                                }}
                                type={PredefinedDataTypes.CITY}
                                value={formData.place as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "state") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e, state_code) => {
                                  setFormData({
                                    ...formData,
                                    state: e,
                                    gstStateCode: state_code
                                      ? state_code
                                      : EMPTY_STRING,
                                  });
                                }}
                                type={PredefinedDataTypes.STATE}
                                value={formData.state as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "country") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    country: e,
                                  });
                                }}
                                type={PredefinedDataTypes.COUNTRY}
                                value={formData.country as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "mobile") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PhoneInput
                                country={"in"}
                                value={formData[field.inputName] as string}
                                onChange={(e: string) => {
                                  handleNumberChange(field.inputName, e);
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === Keys.ENTER) {
                                    e.preventDefault();
                                    handleMUISelectEvent(e);
                                  }
                                }}
                              />
                              {meta.touched && meta.errors[field.inputName] ? (
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              ) : null}
                            </div>
                          );
                        } else {
                          return (
                            <React.Fragment key={key}>
                              <InputHoc
                                LabelName={field.labelName}
                                values={formData[field.inputName]}
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                required={field.required}
                                autoFocus={field.autoFocus}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        }
                      }
                    )}
                  </div>
                </div>
                <Button mode="save" type="submit" />
                <Button mode="clear" type="button" onClick={hanldeClear} />
                <Button mode="cancel" onClick={() => setModalFlag(false)} />
                <MessageModal
                  handleClose={handleClose}
                  modalFlag={message.flag}
                  operation={message.operation}
                  value={message.message}
                />
              </Form>
            );
          }}
        </Formik>
        <LoadingModal
          flag={
            GetSubsidiarySiteNodeByIdLoading ||
            AddSubsidiarySiteLoading ||
            UpdateSubsidiarySiteLoading
          }
        />
      </div>
    </>
  );
};

export default AssetSite;
